export enum ResidentPostType {
  AskForHelp = "askHelp",
  Inform = "inform",
  SellItem = "sellItem",
}

export const MAX_AMOUNT_IMAGES_PER_POST = 20;
